
import { ApiResponse, handleApiCall, setSession } from './api';
import { SHA512 } from 'crypto-js';
import Timezone from 'timezone-enum';

export async function signIn(user: string, rawPassword: string, browser: string):
    Promise<ApiResponse<{ token: string }>> {

    const password = SHA512(rawPassword).toString();

    const response = await handleApiCall<{ token: string }>('post', 'v2/public/auth', {
        body: {
            username: user,
            password,
            browser
        }
    })

    if (response.success) {
        const { token } = response.data;
        setSession(token)
    }

    return response;
}

export async function signInWithGoogle(user: string, jwt: string, name: string, browser: string, lang: string, country: string):
    Promise<ApiResponse<{ token: string }>> {

    const response = await handleApiCall<{ token: string }>('post', 'v2/public/auth', {
        body: {
            username: user,
            jwt,
            name,
            browser,
            lang,
            timezone: Timezone[Intl.DateTimeFormat().resolvedOptions().timeZone],
            country
        }
    })

    if (response.success) {
        const { token } = response.data;
        setSession(token)
    }

    return response;
}

export async function signInWithOtp(user: string, otp: string, browser: string):
    Promise<ApiResponse<{ token: string }>> {

    const response = await handleApiCall<{ token: string }>('post', 'v2/public/auth', {
        body: {
            username: user,
            otp,
            browser
        }
    })

    if (response.success) {
        const { token } = response.data;
        setSession(token)
    }

    return response;
}

export async function requestUserOtp(user: string, browser: string):
    Promise<ApiResponse<{ token: string }>> {


    const response = await handleApiCall<{ token: string }>('post', 'v2/public/auth', {
        body: {
            username: user,
            browser
        }
    })

    return response;
}

export async function signUp(first_name: string,
    last_name: string, username: string, lang: string, country: string): Promise<ApiResponse<void>> {

    return await handleApiCall<void>('post', 'v2/public/register', {
        body: {
            username,
            first_name,
            last_name,
            lang,
            timezone: Timezone[Intl.DateTimeFormat().resolvedOptions().timeZone],
            country
        }
    })
}

export async function getPublicSettings(): Promise<ApiResponse<{ emailing_enabled: boolean, registration_enabled: boolean }>> {

    return await handleApiCall('get', 'v2/public/settings');
}

export async function getGeoLocation(): Promise<ApiResponse<{ country: string }>> {
    return await handleApiCall('get', 'v2/public/geolocation');
}

export async function verify(token: string, browser: string): Promise<ApiResponse<{ token: string }>> {

    const response = await handleApiCall<{ token: string }>('post', 'v2/public/verify', { body: { token, browser } });

    if (response.success) {
        const { token } = response.data;
        setSession(token)
    }

    return response;
}
